

export class ServiceWorkerNoSupportError extends Error {

	constructor() {
		super('ServiceWorker is not supperted.');
	}
}

export default function registerServiceWorkerIfSupported(options) {

	if ('serviceWorker' in navigator) {
		return navigator.serviceWorker.register("/" + "index.js", options);
	}

	return Promise.reject(new ServiceWorkerNoSupportError());
}




//////////////////
// WEBPACK FOOTER
// ./node_modules/service-worker-loader/lib!./src/sw/index.js
// module id = 1vU4
// module chunks = 1